import uaNum from './uaJudgment.js';

/**
 * サンプルクラス
 * @constructor
 */
 class HoverAdd {

  constructor() {

    this._addClassNameval = 'is-hover';
    this._uaNum = uaNum;

    this.init();
  }
  /**
   * サンプル
   */
  init() {
    if (this._uaNum === 0) { // PCだった場合
      const clasName1 = '.js-hoverAdd';
      if (document.querySelector(clasName1)) this.hoverAddClass(clasName1);
      const clasName2 = '.js-hoverAdd--c1';
      if (document.querySelector(clasName2)) this.hoverAddClass01(clasName2, '.m-arrowBtn');

    }

    if (document.querySelector('.js-hover--history')) {
      // ヒストリーページ用の判定（判定用に500ms遅らせている）
      setTimeout(() => {
        this.hoverAddClassHistory(this._uaNum);
      }, 3000);
    }
  }

  // ヒストリーページ用
  hoverAddClassHistory(uaNum) {
    const bodyElement = document.body;
    const addClassNameval = 'is-hover';
    const targetItem = document.querySelectorAll('.js-hover--history');

    if (uaNum === 0) { // PC or iPadだった場合
      if (bodyElement.classList.contains('iPad')) {
        // iPad の場合
        targetItem.forEach(el => {
          el.addEventListener('mouseover', () => {
            el.classList.add(addClassNameval);
            // 1秒後にクラスを削除
            setTimeout(() => {
              el.classList.remove(addClassNameval);
            }, 300); // 300ミリ秒（＝1秒）
          });
        });
      } else {
        //pc の場合
        targetItem.forEach(el => {
          el.addEventListener('mouseover', () => {
            el.classList.add(addClassNameval);
          });
          el.addEventListener('mouseleave', () => {
            el.classList.remove(addClassNameval);
          });
        });
      }
    } else if (uaNum === 1) { // SPだった場合
      targetItem.forEach(el => {
        el.addEventListener('mouseover', () => {
          el.classList.add(addClassNameval);
          // 1秒後にクラスを削除
          setTimeout(() => {
            el.classList.remove(addClassNameval);
          }, 300); // 300ミリ秒（＝1秒）
        });
      });
    }
  }

  // デフォルト hover対象を指定して、自信にclass名をつける
  hoverAddClass (hoverTarget) {
    const targetItem = document.querySelectorAll(hoverTarget);
    targetItem.forEach(el => {
      el.addEventListener('mouseover', () => {
        el.classList.add(this._addClassNameval);
      });
      el.addEventListener('mouseleave', () => {
        el.classList.remove(this._addClassNameval);
      });
    });
  }
  // case01 hover対象を指定して、class名を対象内の指定のDOMにつける
   hoverAddClass01(hoverTarget, classAddTarget) {
    const targetItem = document.querySelectorAll(hoverTarget);
    targetItem.forEach(el => {
      const btnElem = el.querySelector(classAddTarget);
      el.addEventListener('mouseover', () => {
        btnElem.classList.add(this._addClassNameval);
      });
      el.addEventListener('mouseleave', () => {
        btnElem.classList.remove(this._addClassNameval);
      });
    });
  }
  // case02 hover対象を指定して、class名を指定のDOMにつける
  // 1対1でなくても、複数X単数、単数x複数も可能です
  hoverAddClass02 (hoverTarget, classAddTarget) {
    const targetItem = document.querySelectorAll(hoverTarget);
    const targetDom = document.querySelectorAll(classAddTarget);
    targetItem.forEach(el => {
      el.addEventListener('mouseover', () => {
        targetDom.forEach(elem => {
          elem.classList.add(this._addClassNameval);
        });
      });
      el.addEventListener('mouseleave', () => {
        targetDom.forEach(elem => {
          elem.classList.remove(this._addClassNameval);
        });
      });
    });
  }
}

export default HoverAdd;
